import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class StaffData {

  constructor(
    public afDb: AngularFireDatabase,
  ) { }

}


// WEBPACK FOOTER //
// ./src/providers/staff.ts